import React from 'react';
import Form from '../components/ContactPageComponents/Form';
import Layout from '../components/layout';
import Img from 'gatsby-image/withIEPolyfill';
import { graphql } from 'gatsby';
import SEO from '../components/seo';
import Head from '../components/globals/Head';
import '../components/ContactPageComponents/Contact.css';

const Contact = (props) => (
	<Layout>
		<SEO title="Contact" keywords={[ `masu`, `design`, `front-end web developing` ]} />
		<Head />
		<div className={'wrap_contact'}>
			<Img
				className="background-contact"
				alt="grey abstract background"
				objectFit="cover"
				objectPosition="center center"
				fluid={props.data.imageContact.childImageSharp.fluid}
			/>
			<Form />
		</div>
	</Layout>
);

export default Contact;
export const imag = graphql`
	query {
		imageContact: file(relativePath: { eq: "Bg-Contact-opt.jpg" }) {
			childImageSharp {
				fluid(maxWidth: 1920) {
					...GatsbyImageSharpFluid_withWebp
				}
			}
		}
	}
`;
